import React from 'react';
import './styles/PersonIcon.scss';
import FA from 'utils/FA';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';

const PersonIcon = ({ personName, notificationCount = 0, sameLine = false }) => (
  <div className={sameLine ? 'sp-person-same-line' : 'sp-person'}>
    {sameLine && <div className='sp-person-name'>{personName}</div>}
    <div className={`fa-layers fa-fw sp-person-icon${sameLine ? '-small' : ''}`}>
      <FA icon={faUser} className={sameLine ? 'fa-2x' : 'fa-3x'} />
      {notificationCount > 0 && <span className='fa-layers-counter fa-4x'>{notificationCount}</span>}
    </div>
    {!sameLine && <div className='sp-person-name'>{personName}</div>}
  </div>
);

export default PersonIcon;
